import { CardContent } from "@mui/material";
import { MprcCard } from "components";
import { MprcContainer } from "components/MprcContainer";
import { MprcRecordInfo } from "components/MprcRecordInfo";
import { AuditLogEntityType, RecordInfoDto } from "generated/CoreApi_v1";
import React, { useState } from "react";
import { AuditLogDialog } from "views/common/AuditLog/AuditLogDialog";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    channelId: string;
    name: string;
    recordInfo: RecordInfoDto;
}

////////////////////////////////////////////////////////////////////////////

export const EditChannelFooter: React.FC<IProps> = ({ channelId, name, recordInfo }) => {

    const [dialog, setDialog] = useState<any>(null);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcContainer>
            <MprcCard>
                {dialog}
                <CardContent>
                    <MprcRecordInfo
                        recordInfo={recordInfo}
                        onHistoryClick={
                            () => {
                                setDialog(
                                    <AuditLogDialog
                                        title={name}
                                        entityType={AuditLogEntityType.Channel}
                                        entityKey={[channelId]}
                                        onClose={() => setDialog(null)}
                                    />
                                );
                            }
                        }
                    />
                </CardContent>
            </MprcCard>
        </MprcContainer>
    );
};
